<template>
  <status-string :text="status.text" :class="status.class" />
</template>

<script setup lang="ts">
import { toRef } from 'vue';
import StatusString from '@/core/components/common/StatusString.vue';

const props = defineProps<{
  status: string;
}>();

const status = toRef(() => {
  switch (props.status) {
    case 'inSale':
      return {
        class: 'text-green',
        text: 'В продаже',
      };
    case 'closed':
      return {
        class: 'text-inactive',
        text: 'Закрыто',
      };
    case 'inProgress':
      return {
        class: 'text-yellow',
        text: 'Настройка не завершена',
      };
    case 'inModeration':
      return {
        class: 'text-blue',
        text: 'На рассмотрении',
      };
    default: {
      return {
        class: '',
        text: '',
      };
    }
  }
});
</script>

<style scoped lang="scss"></style>
